import { render } from "./site-header-garage.vue?vue&type=template&id=6ea4f0e0"
import script from "./site-header-garage.vue?vue&type=script&lang=js"
export * from "./site-header-garage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__